import { ApiOptions } from '../../api-options.decorator';
import { DefaultParams } from '../../default-params.model';

import { ApiBaseMidBack } from './base';
import { TprAccountDto } from './types/tprAccountDto';
import { TprLegalEntityDto } from './types/tprLegalEntityDto';
import { TprPartyDto } from './types/tprPartyDto';

/**
 * @internal
 */
export class ApiMidbackThirdPartyReferential extends ApiBaseMidBack {
  /**
   * Fetch a gemforce account using the tpr api because they are identical
   * @param query account's name
   * @returns the account with the name in params
   */
  getGemforceAccountsByName(query: string) {
    return this.get<TprAccountDto[]>('/third-party-referential/account', new DefaultParams({ search: query }));
  }

  getLegalEntities(search: string) {
    return this.get<TprLegalEntityDto[]>(`/third-party-referential/legal-entities`, new DefaultParams({ search }));
  }

  @ApiOptions({ interceptErrors: false })
  getThirdPartyReferentialByName(search: string, isDMGActive: boolean = true) {
    return this.get<TprPartyDto[]>(`/third-party-referential/parties`, new DefaultParams({ search, isDMGActive }));
  }
}
